import { SxProps } from '@mui/material'

import theme from '../../../../styles/themes/default.theme'

const styles = {
  profileMenu: (marginTop: string = '10px') =>
    ({
      [theme.breakpoints.down('md')]: {
        '& .MuiMenu-paper': {
          width: '100%',
          maxWidth: '100%',
          left: 0,
          right: 0,
          boxShadow: 'none',
          mt: '10px',
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          [theme.breakpoints.down('md')]: {
            mt: `calc(${marginTop} - 8px)`
          }
        },
        '& .MuiPaper-root': {
          left: 'unset!important'
        },
        '& .MuiList-root': {
          padding: 0,
          marginBottom: '-1px'
        }
      }
    }) as SxProps,

  rightSideArea: {
    display: 'flex',
    alignItems: 'center'
  } as SxProps,

  paper: {
    elevation: 0,
    sx: {
      filter: 'drop-shadow(0px 1px 0px rgba(0,0,0,0.32))',
      [theme.breakpoints.up('md')]: {
        overflow: 'visible',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
        mt: 1.5,
        width: 150,

        '& .MuiAvatar-root': {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1
        },

        '&::before': {
          content: '""',
          display: 'block',
          position: 'absolute',
          top: 0,
          right: 80,
          width: 10,
          height: 10,
          bgcolor: 'background.paper',
          transform: 'translateY(-50%) rotate(45deg)',
          zIndex: 0
        }
      }
    }
  },

  // Role Switcher Section
  roleSwitcherSection: {
    backgroundColor: '#F8F7FF',
    width: '100%'
  } as SxProps,

  roleSwitcherHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    px: '20px',
    height: '64px',
    cursor: 'pointer',
    userSelect: 'none'
  } as SxProps,

  chevron: (isOpen: boolean) =>
    ({
      display: 'flex',
      transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.2s ease'
    }) as SxProps,

  roleLabelText: {
    fontSize: '11px',
    fontWeight: 600,
    color: '#9CA3AF',
    letterSpacing: '1px',
    lineHeight: 1,
    textTransform: 'uppercase'
  } as SxProps,

  currentRoleText: {
    fontSize: '15px',
    fontWeight: 600,
    color: '#111827'
  } as SxProps,

  roleOption: (isActive: boolean) =>
    ({
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      height: '52px',
      pl: isActive ? '20px' : '50px',
      pr: '20px',
      cursor: 'pointer',
      backgroundColor: isActive ? '#EEF2FF' : 'transparent',
      '&:hover': {
        backgroundColor: isActive ? '#EEF2FF' : 'rgba(0,0,0,0.04)'
      }
    }) as SxProps,

  roleOptionText: (isActive: boolean) =>
    ({
      fontSize: '15px',
      fontWeight: isActive ? 600 : 'normal',
      color: isActive ? '#4F46E5' : '#374151'
    }) as SxProps,

  divider: {
    height: '1px',
    backgroundColor: '#E5E7EB',
    width: '100%'
  } as SxProps,

  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    height: '52px',
    px: '20px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.04)'
    }
  } as SxProps,

  navItemText: {
    fontSize: '15px',
    fontWeight: 'normal',
    color: '#111827'
  } as SxProps
}

export default styles
